import { render, staticRenderFns } from "./InboxToolbarV2026.vue?vue&type=template&id=f1a83f08&scoped=true"
import script from "./InboxToolbarV2026.vue?vue&type=script&lang=js"
export * from "./InboxToolbarV2026.vue?vue&type=script&lang=js"
import style0 from "./InboxToolbarV2026.vue?vue&type=style&index=0&id=f1a83f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a83f08",
  null
  
)

export default component.exports